// 物件カードの画像クリック → モーダル開閉
// [data-estate-modal-open] クリックで開く / [data-estate-modal-close] と ESC で閉じる
const main = () => {
    const triggers = document.querySelectorAll('[data-estate-modal-open]');
    if (triggers.length === 0) return;

    const open = (modal) => {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    };

    const close = (modal) => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    };

    triggers.forEach((trigger) => {
        const id = trigger.dataset.estateModalOpen;
        const modal = document.querySelector(`[data-estate-modal="${id}"]`);
        if (!modal) return;

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            open(modal);
        });

        modal.querySelectorAll('[data-estate-modal-close]').forEach((closer) => {
            closer.addEventListener('click', (e) => {
                e.preventDefault();
                close(modal);
            });
        });

        // オーバーレイ（背景）クリックで閉じる（data-estate-modal-overlay-close="disabled" の場合は無効）
        const overlay = modal.querySelector('[data-estate-modal-overlay]');
        if (overlay && modal.dataset.estateModalOverlayClose !== 'disabled') {
            overlay.addEventListener('click', (e) => {
                if (e.target !== overlay) return;
                close(modal);
            });
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        document.querySelectorAll('[data-estate-modal].is-open').forEach(close);
    });
};

export default main;
